const categoriesKeys = {
  module: ['categories'] as const,
  list: () => [...categoriesKeys.module, 'list'] as const,
  listWithFilters: (filters: any) =>
    [...categoriesKeys.list(), filters] as const,
  details: (id: string) => [...categoriesKeys.module, 'details', id] as const,
};

export default categoriesKeys;
